import React from 'react'

function Instructions() {
    return (
        <>
            <div className="w-3/5 mx-auto  bg-gradient-to-r from-red-700 to-pink-700 text-white  shadow-xl p-10">

                {/* ENGLISH */}
                <div className="mb-10">

                    <h3 className="text-xl font-bold mb-6">
                        Cancellation Policy
                    </h3>

                    <ul className="space-y-4 list-disc pl-8 text-sm leading-5 font-medium">

                        <li>
                            For cancellation from 2 day(s) before booking date,
                            the cancellation charge will be 25% of your booking amount.
                        </li>

                        <li>
                            Once booking date approved booking date can't be changed.
                        </li>

                        <li>
                            NAC Kuchinda has got the sole right to honor or dishonor
                            any reservation without any prior notice.
                        </li>

                    </ul>

                </div>

                {/* ODIA */}
                <div className="mb-10">

                    <h3 className="text-xl font-bold mb-6">
                        ବାତିଲ ନୀତି
                    </h3>

                    <ul className="space-y-4 list-disc pl-8 text-sm leading-5 font-medium">

                        <li>
                            ବୁକିଂ ତାରିଖର ୨ ଦିନ ପୂର୍ବରୁ ବାତିଲ ପାଇଁ,
                            ବୁକିଂ ରାଶି ଅନୁଯାୟୀ 25% ଦେବାକୁ ହେବ ।
                        </li>

                        <li>
                            ବୁକିଂ ତାରିଖ ଅନୁମୋଦିତ ହେବା ପରେ ବୁକିଂ ତାରିଖ
                            ପରିବର୍ତ୍ତନ କରାଯାଇପାରିବ ନାହିଁ ।
                        </li>

                        <li>
                            NAC Kuchinda କୌଣସି ସଂରକ୍ଷଣକୁ ଅନୁମୋଦନ କିମ୍ବା
                            ନାମଞ୍ଜୁର କରିବା ଅଧିକାର ରଖେ ।
                        </li>

                    </ul>

                </div>

                {/* IMPORTANT */}
                <div>

                    <h3 className="text-xl font-bold mb-6">
                        ଅତ୍ୟାବଶ୍ୟକ ସୂଚନା
                    </h3>

                    <ul className="space-y-4 list-disc pl-8 text-sm leading-5 font-medium">

                        <li>
                            ଏକ ଦିନର ଅନୁମୋଦିତ ବୁକିଂ କେବଳ 24 ଘଣ୍ଟା ପାଇଁ ଲାଗୁ ଅଟେ ।
                        </li>

                        <li>
                            ବୁକିଂ ଅନୁମୋଦିତ ଦିନ ପୂର୍ବରୁ କୌଣସି ସାମଗ୍ରୀ
                            NAC Kuchinda କର୍ତ୍ତୃପକ୍ଷ ଙ୍କ ଠାରୁ ଅନୁମତି ବିନା ଆଣିପାରିବେ ନାହିଁ ।
                        </li>

                        <li>
                            ଥରେ ବୁକିଂ ତାରିଖ ଅନୁମୋଦିତ ହେଲେ ବୁକିଂ ତାରିଖ
                            ପରିବର୍ତ୍ତନ ହୋଇପାରିବ ନାହିଁ ।
                        </li>

                    </ul>

                </div>

            </div>
        </>
    )
}

export default Instructions